<template>
  <div class="footer">
    <div v-if="+$db.get('Hide_Company_Info') !== 1" class="copyright">
      Copyright
      <a-icon type="copyright"/>
      <span v-html="copyright"></span>
      |&nbsp;<span v-html="copyno"></span>
    </div>
    <div v-else class="copyright"><span v-html="copyno"></span></div>
  </div>
</template>

<script>
export default {
  name: 'GlobalFooter',
  props: ['copyright', 'copyno']
}
</script>

<style lang="less" scoped>
  .footer {
    padding: 0 16px;
    margin: 32px 0;
    text-align: center;

    .copyright {
      color: rgba(0, 0, 0, .45);
      font-size: 14px;
      i {
        font-size: .8rem !important;
      }
    }

    &a {
      text-decoration: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/common/GlobalFooter.vue